import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestSearch } from '../../../SHARED/actions/search.actions';
import SearchForm from './searchesForm';

class Searches extends Component {

    doSearch(data) {
        this.props.requestSearch(data);
    }

    render() {
        return (
            <div className="searches">
                <SearchForm onSubmit={this.doSearch} cinemaLocations={this.props.cinemaLocations}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    cinemaLocations: state.filters.cinemaLocations
});
export default connect(mapStateToProps, {requestSearch})(Searches);



// WEBPACK FOOTER //
// ./src/FO/components/searches/searches.component.js